import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Loader.module.scss';
import isBrowser from '~/utils/isBrowser';

class Loader extends Component {
  state = {
    exitting: false,
    hidden: false,
  };

  static propTypes = {
    hide: PropTypes.bool.isRequired,
  };

  static getDerivedStateFromProps({ hide }, { exitting, hidden }) {
    if (!hide) {
      return {
        hidden: false,
      };
    } else if (hidden) {
      return null;
    }

    return {
      exitting: hide,
    };
  }

  shouldComponentUpdate(nextProps, { exitting }) {
    if (!exitting) {
      return true;
    }

    setTimeout(
      () =>
        this.setState({
          exitting: false,
          hidden: true,
        }),
      parseInt(styles.exitTimeout, 10),
    );

    return true;
  }

  render() {
    const { exitting, hidden } = this.state;

    if (hidden || !isBrowser) {
      return null;
    }

    return (
      <div className={`${styles.loader} ${exitting ? styles.fadeOut : ''}`}>
        <div className={styles.spinner}>
          <div></div> <div></div> <div></div> <div></div> <div></div>
        </div>
      </div>
    );
  }
}

export default Loader;
